import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

/* ------------------ SmoothLightbox (pure React) ------------------ */
function SmoothLightbox({ items, index, onClose, onPrev, onNext }) {
  // Lock body scroll while open
  useEffect(() => {
    if (index >= 0) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => (document.body.style.overflow = prev);
    }
  }, [index]);

  // Keyboard nav
  useEffect(() => {
    if (index < 0) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [index, onClose, onPrev, onNext]);

  if (index < 0) return null;
  const item = items[index];

  return (
    <div className="slb-overlay" role="dialog" aria-modal="true" aria-label="Image preview">
      <div className="slb-backdrop" onClick={onClose} />

      <div className="slb-inner" aria-hidden={false}>
        <button className="slb-close" onClick={onClose} aria-label="Close">✕</button>

        <button className="slb-nav slb-prev" onClick={onPrev} aria-label="Previous">‹</button>

        <figure className="slb-media">
          <img src={item.src} alt={item.alt || item.caption || `Image ${index + 1}`} className="slb-img" />
          {item.caption && <figcaption className="slb-caption">{item.caption}</figcaption>}
          <div className="slb-counter">{index + 1} / {items.length}</div>
        </figure>

        <button className="slb-nav slb-next" onClick={onNext} aria-label="Next">›</button>
      </div>
    </div>
  );
}

/* ------------------ Main page component ------------------ */
export default function Brandingandgraphicdesign() {
  const gallery = useMemo(
    () =>
      Array.from({ length: 29 }, (_, i) => {
        const num = i + 1;
        return {
          src: require(`../assets/img/work/branding/branding-img${num}.jpg`),
          caption: "Branding & Designing",
          alt: `Brand ${num}`,
        };
      }),
    []
  );

  const [activeIndex, setActiveIndex] = useState(-1);

  const openAt = useCallback((i) => setActiveIndex(i), []);
  const closeLightbox = useCallback(() => setActiveIndex(-1), []);
  const prev = useCallback(() => setActiveIndex((prev) => (prev <= 0 ? gallery.length - 1 : prev - 1)), [gallery.length]);
  const next = useCallback(() => setActiveIndex((prev) => (prev >= gallery.length - 1 ? 0 : prev + 1)), [gallery.length]);

  return (
    <>
      <section className="innerPages">
        <Container>
          <div>
            <Row data-aos="fade-up" data-aos-duration="3000">
              <Col lg={3}>
                <div className="innerPages-box1">
                  <h1>Elixir & AR <span>Branding & Graphic</span></h1>
                  <h4>A Complete Communication Solution</h4>
                </div>
              </Col>

              <Col lg={6}>
                <div className="innerPages-box2">
                  <div className="servicesInner-content">
                    <Row>
                      <h4>Creative Branding & <span>Graphic Design</span></h4>
                      <Col md={12}>
                        <p>In today’s competitive market, a memorable brand story is essential to connect with your audience and stand out. At Elixir Advertising & AR Graphics, we are leaders in innovative branding solutions, helping businesses, entrepreneurs, and creatives define and elevate their brand identity.</p>
                        <p>We transform ideas into stunning visuals, designing unique logos, cohesive brand identities, and compelling promotional graphics. Whether you’re launching a new venture or reimagining an existing brand, we craft bold, memorable designs that leave a lasting impression.</p>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>

              <Col lg={3}>
                <div className="innerPages-box3">      
                  <div className="logoPart">
                    <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                    <hr />
                    <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                    <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                  </div>
                </div> 
              </Col>
            </Row>
          </div>

          <div>
            <Row data-aos="fade-up" data-aos-duration="3000">
              <Col lg={3}>
                <div className="innerPages-box4">
                  <ul className="recentproLinks">
                    <hr />
                    <li>Logo Design</li>
                    <li>Brand Identity</li>
                    <li>Brand Auditing</li>
                    <li>Brochure Design</li>
                    <li>Product Design</li>
                    <li>Annual Reports</li>
                    <li>Print Services</li>
                  </ul>
                </div>
              </Col>

              <Col lg={9}>
                <div className="aboutPages-box5">
                  <div className="servicesInner-content">
                    <Row>
                      <h4>Recent <span>Works</span></h4>

                      {gallery.map((g, i) => (
                        <Col key={i} lg={4} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
                          <div className="latestWork-box" role="button" onClick={() => openAt(i)}>
                            <img src={g.src} className="img-fluid" alt={g.alt} />
                            <div className="overlay">
                              <div className="text">
                                <h4>BEST</h4>
                                <p>{g.caption}</p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}

                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      {/* Smooth/react lightbox */}
      <SmoothLightbox items={gallery} index={activeIndex} onClose={closeLightbox} onPrev={prev} onNext={next} />
    </>
  );
}
